module.exports = __webpack_public_path__ + "media/momenta_fr.cd4ccc0a.mp4";